import BlurPillButton from './BlurPillButton';

const PageHeaderCapsuleButton = ({ children, className = '', ...buttonProps }) => (
    <BlurPillButton
        className={`pageHeaderActionButton pageHeaderCapsuleButton ${className}`.trim()}
        style={{ height: 'auto', padding: '6px 16px' }}
        labelStyle={{ fontSize: '14px', fontWeight: '500' }}
        label={children}
        {...buttonProps}
    />
);

export default PageHeaderCapsuleButton;
